<!-- Loading Screen -->
<app-loader [isLoading]="isLoading()"></app-loader>

<!-- Dashboard Layout -->
<div class="dashboard-layout" [class.loading]="isLoading()">
    <!-- Sidebar Navigation -->
    <aside class="sidebar">
        <!-- Brand Header -->
        <div class="sidebar-header" (click)="navigateToWelcome()" style="cursor: pointer;">
            <h1 class="brand-title">Suntur Quri Wasi</h1>
            <p class="brand-subtitle">Panel de Administración</p>
        </div>

        <!-- Navigation Menu -->
        <nav class="sidebar-nav">
            @for (item of menuItems(); track item.id) {
            <button class="nav-item" [class.active]="currentSection() === item.id" (click)="navigateToSection(item.id)">
                <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path [attr.d]="item.icon"></path>
                </svg>
                <span class="nav-text">{{ item.label }}</span>
            </button>
            }
        </nav>

        <!-- Logout Button -->
        <button class="logout-button" (click)="logout()">
            <svg class="nav-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span class="nav-text">Cerrar Sesión</span>
        </button>
    </aside>

    <!-- Main Content Area -->
    <main class="main-content">
        <!-- Top Bar -->
        <app-top-bar></app-top-bar>

        <!-- Router Outlet for Child Routes (Inventory, etc.) -->
        <router-outlet></router-outlet>
        @if (currentSection() !== 'dashboard' && currentSection() !== 'welcome' && currentSection()
        !== 'usuarios' &&
        currentSection() !== 'habitaciones' && currentSection() !== 'huespedes' && currentSection()
        !== 'reservaciones' && currentSection() !== 'inventario' && currentSection() !== 'ventas' && currentSection()
        !== 'limpieza')
        {
        <div class="section-placeholder">
            <div class="placeholder-content">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z">
                    </path>
                </svg>
                <h3>{{ getSectionTitle(currentSection()) }}</h3>
                <p>Esta sección está en desarrollo</p>
            </div>
        </div>
        }

    </main>
</div>